import type { Ad } from "../../../../types/ads/adResource";

const createAdResource = ({
  placement,
  placementRules,
  shouldKeepSizeOnCollapse = false,
  startAsCollapsed = false,
  placeholderValues,
  user,
  context,
}: Omit<Ad, "type" | "havePlacementRule">): Ad => {
  return {
    type: "Ad",
    placement, // defined in placementMap
    placementRules,
    havePlacementRule: placementRules.length > 0,
    shouldKeepSizeOnCollapse,
    startAsCollapsed,
    placeholderValues,
    user,
    context,
  };
};

export { createAdResource };
